<mat-card appearance="outlined">
  <mat-card-content>
    <div class="title">
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.TITLE' | translate }}
    </div>
    <div class="subtitle">
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.DESCRIPTION' | translate }}
    </div>
    <div class="settings">
      @if (!loadingAvailabilityForm) {
        <form
          [formGroup]="availabilityForm"
          (ngSubmit)="completeSetup()"
          >
          <div class="row row-gutters">
            <div class="col col-xs-12 col-sm-6">
              <glxy-form-field [required]="true">
                <glxy-label>
                  {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.LABELS.START_TIME' | translate }}
                </glxy-label>
                <select [formControlName]="'selectedStartTime'">
                  @for (timeOption of timeOptions; track timeOption) {
                    <option [value]="timeOption">
                      {{ timeOption | date: 'shortTime' }}
                    </option>
                  }
                </select>
              </glxy-form-field>
            </div>
            <div class="col col-xs-12 col-sm-6">
              <glxy-form-field [required]="true">
                <glxy-label>
                  {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.LABELS.END_TIME' | translate }}
                </glxy-label>
                <select [formControlName]="'selectedEndTime'">
                  @for (timeOption of timeOptions; track timeOption) {
                    <option [value]="timeOption">
                      {{ timeOption | date: 'shortTime' }}
                    </option>
                  }
                </select>
              </glxy-form-field>
            </div>
          </div>
          <div>
            <glxy-form-field [required]="true" [bottomSpacing]="false">
              <glxy-label>Bookable days</glxy-label>
            </glxy-form-field>
          </div>
          <div class="week">
            @for (day of formData.controls; track day; let i = $index) {
              <mat-card
                formArrayName="daysOfWeek"
                class="weekday"
                appearance="outlined"
                >
                <mat-card-title class="weekday-title">
                  <mat-checkbox [formControlName]="i"></mat-checkbox>
                  <div>
                    {{ indexToDayOfWeekMapping[i].name }}
                  </div>
                </mat-card-title>
              </mat-card>
            }
          </div>
          <div class="time-zone-message">
            <glxy-timezone-selector
              [initialTimezone]="timezone"
              (timezoneChanged)="onTimezoneChanged($event)"
            ></glxy-timezone-selector>
          </div>
        </form>
      } @else {
        <div class="form-row fields-row">
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
        </div>
        <div class="form-row fields-row shimmer-margin">
          <div class="shimmer-box stencil-shimmer time-zone-message"></div>
        </div>
        <div class="form-row fields-row day-container">
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
          <div class="shimmer-box stencil-shimmer"></div>
        </div>
      }
    </div>
  </mat-card-content>

</mat-card>

@if ((salesCoachConfig$ | async)?.joinMeetings && selectedCalendarProvider() === 'google' && meetingAppSelection() === AvailableServices.GOOGLE_MEET) {
  <meeting-scheduler-sales-coach-user-config-settings
    [showNamespaceSettings]="false"
    [showUserConfigSaveButton]="false">
  </meeting-scheduler-sales-coach-user-config-settings>
}

